import { useTranslation } from "react-i18next";

import { preDefinedThemes, Theme } from "../../../../../../model/theme";
import { ThemeCard, ThemeCardsSection } from "./styles";

// Circular arrow, drawn in the text's color
export const ResetIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2.4}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true">
    <path d="M3 12a9 9 0 1 0 3-6.7" />
    <path d="M3 4v5h5" />
  </svg>
);

type Props = {
  activeTheme: Theme;
  onSelectTheme: (theme: Theme) => void;
};

/** The predefined themes to try: picking one shows it in the preview; not liked, "Redefinir" beside the title. */
export const PreDefinedColorSection = ({ activeTheme, onSelectTheme }: Props) => {
  const { t } = useTranslation();
  return (
    <ThemeCardsSection>
      {preDefinedThemes.map((theme, index) => (
        <ThemeCard
          tabIndex={0}
          aria-label={t("pages.editor.settings.form.predefinedColors.themeLabel", { number: index + 1 })}
          aria-pressed={theme.id === activeTheme?.id}
          onClick={() => onSelectTheme(theme)}
          onKeyDown={event => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              onSelectTheme(theme);
            }
          }}
          $active={theme.id === activeTheme?.id}
          $primary={theme.editorPrimary || theme.primary}
          $secondary={theme.secondary}
          key={theme.id}>
          Ab
        </ThemeCard>
      ))}
    </ThemeCardsSection>
  );
};
